import { render, staticRenderFns } from "./SelfPagination.vue?vue&type=template&id=3dd79a97&scoped=true&"
import script from "./SelfPagination.vue?vue&type=script&lang=js&"
export * from "./SelfPagination.vue?vue&type=script&lang=js&"
import style0 from "./SelfPagination.vue?vue&type=style&index=0&id=3dd79a97&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd79a97",
  null
  
)

export default component.exports